<template>
	<div id="auth">
		<img id="auth__logo" src="/images/logo/logo.png" alt="Mergers Alliance" />
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'LayoutAuth',
		props: {
		},
	}
</script>

<style lang="scss">
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	#auth {
		@include display-flex;
		@include flex-direction(column);
		@include align-items(center);
		@include justify-content-center;

		#auth__logo {
			margin-bottom: 6rem;
			width: 25.4rem;
			@include flex(0, 0, auto);
		}
	}

	.form--auth {
		@extend %card;
		padding: 4rem;
		width: 49rem;
		max-width: 100%;
		border-color: $secondary;
		@include flex-grow(0);
	}
</style>
